import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, CreditCard, ArrowRight, Trophy, Flame } from 'lucide-react';
function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const stored = localStorage.getItem('combo_countdown_end');
    if (stored) {
      return Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('combo_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return {
    hours,
    minutes,
    seconds
  };
}
export function PricingSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="pricing" className="py-12 bg-white" data-id="element-206">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-207">
        <div className="text-center mb-8" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-black text-matte mb-3" data-id="element-209">
            ELEGÍ TU OPCIÓN
          </h2>
          <div className="w-16 h-1 bg-steel mx-auto mb-6" data-id="element-210"></div>

          {/* Countdown */}
          <div className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-4 bg-red-600 text-white px-6 py-3" data-id="element-211">
            <div className="flex items-center gap-2" data-id="element-212">
              <Flame className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-213" />
              <span className="font-black text-sm uppercase" data-id="element-214">
                70% OFF — Termina en:
              </span>
            </div>
            <div className="flex items-center gap-1 font-mono" data-id="element-215">
              <span className="bg-black/30 px-2 py-1 text-lg font-black" data-id="element-216">
                {String(hours).padStart(2, '0')}
              </span>
              <span className="font-black" data-id="element-217">:</span>
              <span className="bg-black/30 px-2 py-1 text-lg font-black" data-id="element-218">
                {String(minutes).padStart(2, '0')}
              </span>
              <span className="font-black" data-id="element-219">:</span>
              <span className="bg-black/30 px-2 py-1 text-lg font-black" data-id="element-220">
                {String(seconds).padStart(2, '0')}
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-221">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="border-2 border-gray-200 bg-white flex flex-col" data-id="element-222">
            <div className="p-6 bg-gray-50 border-b border-gray-200 text-center" data-id="element-223">
              <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-224">
                📦 Opción 1
              </h3>
              <h4 className="text-2xl font-black text-matte mb-3" data-id="element-225">
                SUPER COMBO PRO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-226">
                <span className="text-lg text-gray-400 line-through font-bold" data-id="element-227">
                  $34.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-steel" data-id="element-228">
                  $19.990
                </span>
                <span className="text-sm text-gray-500" data-id="element-229">ARS</span>
              </div>
              <div className="inline-block bg-red-100 text-red-700 font-bold text-xs px-3 py-1 mt-2 uppercase" data-id="element-230">
                Ahorrás $14.010
              </div>
            </div>

            <div className="p-6 flex-grow flex flex-col" data-id="element-231">
              <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-232">
                {['6 Tomos técnicos', '6 Bonos exclusivos', '480 páginas', 'Acceso inmediato', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center" data-id="element-233">
                    <Check className="w-5 h-5 text-green-600 mr-2.5 flex-shrink-0" data-id="element-234" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-235">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <a href="https://solucionstore.shop/cart/45494138568895:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-steel text-white text-center font-bold py-4 text-lg hover:bg-steel/90 transition-colors uppercase" data-id="element-236">
                Quiero mi Super Combo →
              </a>
            </div>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="border-4 border-gold bg-white flex flex-col relative shadow-2xl transform md:-translate-y-3" data-id="element-237">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-matte font-black px-5 py-1.5 uppercase tracking-widest flex items-center shadow-lg w-max text-xs" data-id="element-238">
              <Trophy className="w-4 h-4 mr-1.5" data-id="element-239" /> Más Elegida
            </div>

            <div className="p-6 bg-matte text-center pt-10" data-id="element-240">
              <h3 className="text-sm font-bold text-gold uppercase tracking-wider mb-1" data-id="element-241">
                🏆 Opción 2
              </h3>
              <h4 className="text-2xl font-black text-white mb-3" data-id="element-242">
                COMBO COMPLETO + PACK PRO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-243">
                <span className="text-lg text-gray-400 line-through font-bold" data-id="element-244">
                  $43.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-gold" data-id="element-245">
                  $27.990
                </span>
                <span className="text-sm text-gray-400" data-id="element-246">ARS</span>
              </div>
              <div className="inline-block bg-gold/20 text-gold font-bold text-xs px-3 py-1 mt-2 uppercase" data-id="element-247">
                Ahorrás $15.010
              </div>
            </div>

            <div className="p-6 flex-grow flex flex-col" data-id="element-248">
              <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-249">
                <li className="flex items-center pb-2.5 border-b border-gray-200" data-id="element-250">
                  <Check className="w-5 h-5 text-green-600 mr-2.5 flex-shrink-0" data-id="element-251" />
                  <span className="font-black text-matte text-sm" data-id="element-252">
                    Todo lo del Super Combo Pro
                  </span>
                </li>
                {['+ Pack de Ingeniería y Diseño Pro', '+ Master-Calc Anti-Inflación', '+ Catálogo de Detalles Técnicos', '+ Manual de Herrajes Giesse/Tanit/Roto', '+ Guía DVH Avanzado + Normativa IRAM'].map((item, i) => <li key={i} className="flex items-center bg-gold/10 px-2.5 py-1.5" data-id="element-253">
                    <ArrowRight className="w-4 h-4 text-gold mr-2 flex-shrink-0" data-id="element-254" />
                    <span className="text-matte font-semibold text-xs" data-id="element-255">
                      {item}
                    </span>
                  </li>)}
                <li className="flex items-center pt-2.5 border-t border-gray-200" data-id="element-256">
                  <Check className="w-5 h-5 text-gold mr-2.5 flex-shrink-0" data-id="element-257" />
                  <span className="font-bold text-matte text-sm" data-id="element-258">
                    530 páginas + Garantía 7 días
                  </span>
                </li>
              </ul>
              <a href="https://solucionstore.shop/cart/45494160785599:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-matte text-center font-black py-4 text-xl hover:bg-gold/90 transition-colors uppercase shadow-[0_0_20px_rgba(212,160,23,0.4)]" data-id="element-259">
                Quiero el Combo Completo →
              </a>
            </div>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 mt-8 text-xs text-gray-500 font-medium" data-id="element-260">
          <span className="flex items-center" data-id="element-261">
            <ShieldCheck className="w-3.5 h-3.5 mr-1" data-id="element-262" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-263">
            <Clock className="w-3.5 h-3.5 mr-1" data-id="element-264" /> Acceso en 5 min
          </span>
          <span className="flex items-center" data-id="element-265">
            <ShieldCheck className="w-3.5 h-3.5 mr-1" data-id="element-266" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-267">
            <CreditCard className="w-3.5 h-3.5 mr-1" data-id="element-268" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}